module.exports = __webpack_public_path__ + "static/Produktdesign-1bc0daaa178af6167ffb9cf2de5b3c89.gif";